module.exports = "query Banners{banners{edges{node{id title backgroundColor link rowId bannerPicture{id picture{id file}}}}}}"